import { gsap, Power1, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MenuToggle } from '../elements/menu-toggle'
import { breakpointUp } from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)

const $html = $('html')
const $body = $('body')
const $header = $('header')
const $menuModal = $('#menu-modal')
const menuToggle = new MenuToggle('.menu-toggle')
let notAnimateMenuUpFlag = false



//-- Responsive levels sub menus --
let activeRespMenu = $('.js-resp-menu[data-id="main"]')
$('.js-open-resp-sub-menu').click(function (){
    let menu = $('.js-resp-menu[data-id="'+ $(this).data('open-id') +'"]')

    if (menu){
        setMenuContainerHeightForMenu(menu);
        gsap.to(activeRespMenu, {left: '-120%', duration: 0.8, ease: 'power2'})
        gsap.fromTo(menu, {left: '120%'}, {left: '0', duration: 0.8, delay: 0.1, ease: 'power2'})
        activeRespMenu = menu
    }
})
$('.js-resp-menu-back').click(function(){
    let menu = $('.js-resp-menu[data-id="'+ $(this).data('back-id') +'"]')

    if (menu){
        setMenuContainerHeightForMenu(menu);
        gsap.to(activeRespMenu, {left: '120%', duration: 0.8, ease: 'power2'})
        gsap.fromTo(menu, {left: '-120%'}, {left: '0', duration: 0.8, delay: 0.1, ease: 'power2'})
        activeRespMenu = menu
    }
})

function setMenuContainerHeightForMenu(menu){
    $('#menu-modal .menu-container').css('min-height', (menu.height() + 100) + 'px')
}






//--- animate in out header --
ScrollTrigger.create({
    start: "top top",
    end: 99999,
    onUpdate: (self) => {
        if (self.scroll.v > 100) {
            self.direction === -1 ? $header.removeClass('hidden') : $header.addClass('hidden')

            $header.addClass('small')
        } else {
            $header.removeClass('small')
        }
    }
});





// -- open close menu ---

function menuOpenAnimations() {
    $html.addClass('modal-visible')
    $header.addClass('menu-visible')
    $menuModal.addClass('modal-visible')

    gsap.fromTo('#menu-modal .menu-modal-backdrop', { opacity: 0}, { opacity: 0.2, duration: 0.5})
    gsap.fromTo('#menu-modal .menu-container', { opacity: 0, right: -50}, { opacity: 1, right: 0, duration: 0.75, ease: Power1.easeOut})

    gsap.fromTo('#menu-modal .resp-menu.main .menu-el',
        { autoAlpha: 0, y: 10 },
        {
            delay: 0.2,
            duration: 0.4,
            autoAlpha: 1,
            y: 0,
            stagger: 0.1,
            ease: Power2.easeInOut,
            onComplete: showMenuContent
        }
    )

    function showMenuContent() {
        gsap.to('#menu-modal .secondary-menu',{ opacity: 1, y: 0, duration: 0.75})
    }

}
function menuCloseAnimations() {
    gsap.to('#menu-modal .menu-modal-backdrop', { opacity: 0, duration: 0.1, delay: 0.15})
    gsap.to('#menu-modal .menu-container', { right: -100, duration: 0.30, ease: Power1.easeIn})
    gsap.to('#menu-modal .menu-container', { opacity: 0, duration: 0.1, ease: Power1.easeIn, delay: 0.2, onComplete: hideMenuModal})

}
function hideMenuModal() {
    notAnimateMenuUpFlag = true
    $html.removeClass('modal-visible')
    $header.removeClass('menu-visible')
    $menuModal.removeClass('modal-visible')

}

$('.js-close-menu').click(function (){
    menuCloseAnimations()
})
document.addEventListener("toggleMenu", function(e) {
    if(e.detail && e.detail.showMenu) {
        menuOpenAnimations()
    } else {
        menuCloseAnimations()
    }
})


// $body.on('click', '.menu-modal-backdrop', function () {
//     menuToggle.closeButton()
// })
//
// $(document).keyup(function(e) {
//     if (e.key === "Escape") { // escape key maps to keycode `27`
//         menuToggle.closeButton()
//     }
// })







//-- search
let searchPopup = $('.js-search-popup')
$('.js-search-ic').click(function(){
    if (searchPopup.css('display') === 'block'){
        searchPopup.fadeOut();
    } else {
        searchPopup.fadeIn();
    }
})
$('.js-close-search-popup').click(function(){
    searchPopup.fadeOut();
})

//-- end search






//-- sub menu
$('.js-open-menu.has-sub-menu').click(function(e){
    let menu_id = $(this).data('menu')
    let menuPopup = $('.js-menu-popup[data-id="'+ menu_id +'"]')

    if (menuPopup.css('display') === 'block') {
        menuPopup.fadeOut();
    } else {
        $('.js-menu-popup').hide()
        menuPopup.fadeIn();
    }
})
$('.js-open-menu.has-sub-menu a').click(function(e){
    e.preventDefault()
})

$("body").click(function(){
    $(".js-menu-popup").fadeOut();
});
// Prevent events from getting pass .popup
$(".js-menu-popup, .js-open-menu").click(function(e){
    e.stopPropagation();
});

// end sub menu






